var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdminlogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 33,
    viewBox: "0 0 29 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.14832 7.14446L13.5229 14.6033V0.0131836L10.8173 1.563V10.0044L6.38094 7.26696L8.93733 5.65057V2.6468L1.14832 7.14446Z",
    fill: "#F4E096"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5399 25.1567L15.2692 17.7458V32.2401L17.9507 30.6929V22.3447L22.3871 25.0795L19.8307 26.6959V29.6065L27.5399 25.1567Z",
    fill: "#F4E096"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3829 5.8371L17.8762 10.0498V4.73732L20.7335 6.44158L23.4896 4.74531L15.2692 0V14.6114L27.7769 7.22182L25.3829 5.8371Z",
    fill: "#F4E096"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.50987 26.4589L10.9154 22.3048V27.6199L8.05812 25.9157L5.40054 27.5507L13.5224 32.2401V17.7458L1.11325 25.0768L3.50987 26.4589Z",
    fill: "#F4E096"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7941 9.03784V18.2196L26.235 16.7283V13.4157L23.3458 15.0454L21.4258 16.1265L26.235 18.9279L28.7941 20.4191V23.4362L18.7948 17.6098L16.2358 16.1185L17.8096 15.2318L18.8667 14.6353L20.784 13.5541L26.235 10.4811L28.7941 9.03784Z",
    fill: "#F4E096"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 23.4362V14.2545L2.55906 15.7457V19.0584L5.44832 17.4287L7.36828 16.3475L2.55906 13.5462L0 12.0549V9.03784L9.99923 14.8643L12.5583 16.3555L10.9845 17.2423L9.92734 17.8388L8.01004 18.9199L2.55906 21.9929L0 23.4362Z",
    fill: "#F4E096"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminlogo);
export default __webpack_public_path__ + "static/media/adminlogo.294257c37474a26d5fc9f8da037bdd25.svg";
export { ForwardRef as ReactComponent };